// Integration hub card primitives. Keep this file independent of the lazy
// /admin/integrations route so shell component registration does not load
// the route body.

export const IntegrationCategoryGroup = {
  flow: 'y',
  gap: 'Z1',

  CategoryHeader: {
    tag: 'h2',
    fontSize: 'A1',
    fontWeight: '700',
    color: 'title',
    margin: '0',
    text: (el, s) => el.call('polyglot', s.label || '')
  },

  Cards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-G)), 1fr))',
    gap: 'A',
    childExtends: 'IntegrationCategoryCard',
    childrenAs: 'state',
    children: (el, s) => s.items || []
  }
}

// One configured kind. It NAVIGATES, so it is a link to the kind's page — it
// was a <button> (no middle-click, and block content inside a button is not
// valid HTML). A card on the branded `card` theme at the card radius; the
// hover lifts it on the `float` shadow, the house cue for a clickable card.
export const IntegrationCategoryCard = {
  extends: 'Link',
  // Everything maps 1:1 except the legacy google_workspace slug.
  href: (el, s) => `/admin/integrations/${s.kind === 'google_workspace' ? 'google' : s.kind}`,
  flow: 'y',
  gap: 'Z1',
  padding: 'A',
  round: 'radiusCard',
  theme: 'card',
  background: 'cardSolid',
  backdropFilter: 'none',
  textDecoration: 'none',
  fontWeight: '400',
  transition: 'Z defaultBezier box-shadow',
  ':hover': { shadow: 'float' },

  Mark: {
    tag: 'div',
    boxSize: 'C1',
    round: 'radiusPill',
    background: 'widgetPlate',
    align: 'center center',
    ariaHidden: 'true',
    Icon: {
      name: (el, s) =>
        ({
          google_workspace: 'googleLogoNormal',
          github: 'github',
          npm: 'npm',
          mcp: 'api',
          slack: 'slack',
          figma: 'figma'
        })[s.kind] || 'sfPlugin',
      boxSize: 'A1',
      color: 'title'
    }
  },
  TopRow: {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    Name: {
      tag: 'span',
      fontSize: 'A',
      fontWeight: '700',
      color: 'title',
      text: (el, s) => s.label
    },
    Pill: {
      padding: 'W2 Y1',
      round: 'radiusPill',
      fontSize: 'Y1',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      // DESIGN_LANGUAGE §8.5 rule 3 — the hue carries in the WASH, the ink stays
      // neutral. White on solid `green` measured 2.81:1 live; see
      // __tests__/statusPillInkContrast.test.js.
      background: 'green.2',
      color: 'title',
      text: (el, s) =>
        s.allows_multiple
          ? el.call('polyglot', 'admin.integrations.card.connected').replace('{count}', s.count)
          : el.call('polyglot', 'admin.integrations.card.configured')
    }
  },

  Description: {
    tag: 'p',
    fontSize: 'Z2',
    color: 'caption',
    margin: '0',
    text: (el, s) => s.description || ''
  }
}
